import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import FormField from '../../shared/components/FormField';
import CardBody from '../../shared/components/CardBody';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as typeDocumentsActions from '../actions/typeDocumentsActions';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DocumentSchemaType from '../../shared/model/DocumentSchemaType';

class TypeDocumentsFormCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = { document_schema_type_id: props.initialValues.document_schema_type_id };
    }

    componentWillMount() {
        this.props.typeDocumentsActions.getFileTypes();
    }

    onSubmit = (values) => {
        const data = { ...values };
        data.file_types = data.filetypes;
        switch ( values.document_schema_type_id ) {
            case DocumentSchemaType.LINKED_WORK_COMPANY:
                data.document_link_type_id = 1;
                data.document_schema_type_id = DocumentSchemaType.LINKED;
                break;
            case DocumentSchemaType.LINKED_COMPANY_COMPANY:
                data.document_link_type_id = 2;
                data.document_schema_type_id = DocumentSchemaType.LINKED;
                break;
            case DocumentSchemaType.LINKED_WORK_COMPANY_COMPANY:
                data.document_link_type_id = 3;
                data.document_schema_type_id = DocumentSchemaType.LINKED;
                break;
            default:
                data.document_link_type_id = null;
        }

        if ( values.document_schema_type_id !== DocumentSchemaType.LINKED_WORK_COMPANY
            && values.document_schema_type_id !== DocumentSchemaType.LINKED_COMPANY_COMPANY
            && values.document_schema_type_id !== DocumentSchemaType.LINKED_WORK_COMPANY_COMPANY ) {
            data.monthly = null;
            data.construction_presence = null;
        } else if ( !data.monthly ) {
            data.construction_presence = null;
        }
        if ( values.document_schema_type_id !== DocumentSchemaType.MONTHLY ) {
            data.multiple_validation = null;
        } else {
            data.multiple_validation = data.multiple_validation ? data.multiple_validation : false;
            data.is_rnt = data.is_rnt ? data.is_rnt : false;
            data.is_certificado_hacienda_contratista = data.is_certificado_hacienda_contratista ? data.is_certificado_hacienda_contratista : false;
        }

        if ( this.props.typedocument ) {
            this.props.typeDocumentsActions.updateTypeDocument(data);
        } else {
            this.props.typeDocumentsActions.addTypeDocument(data);
        }
    };

    renderField(field) {
        return <FormField field={field}/>;
    }

    renderRadioGroup(
        {
            input,
            meta: { touched, error },
            ...rest
        },
    ) {
        return (
            <div test-id="form-categories">
                <RadioButtonGroup
                    {...input}
                    {...rest}
                    valueSelected={input.value}
                    onChange={(event, value) => input.onChange(value)}
                />
                <div className="text-error" style={{ clear: 'both', paddingBottom: '10px' }}>
                    {touched ? error : ''}
                </div>
            </div>
        );
    }

    renderSelectField(
        {
            input,
            label,
            meta: { touched, error },
            children,
            ...custom
        },
    ) {
        return (
            <SelectField
                floatingLabelText={label}
                errorText={touched && error}
                {...input}
                onChange={(event, index, value) => input.onChange(value)}
                children={children}
                {...custom}
            />
        );
    }

    render() {
        const { document_schema_type_id } = this.state;
        const {
            formValues,
            fileTypes,
            handleSubmit,
            typedocument,
            schemaOptions,
            loading,
            currentContractor,
            disabled,
            disabledSchemaTypeField,
        } = this.props;

        const title = I18nUtils.tr(typedocument ? 'TR_EDITAR_TIPO_DE_DOCUMENTO' : 'TR_CREAR_TIPO_DE_DOCUMENTO');
        const submitLabel = I18nUtils.tr(typedocument ? 'TR_GUARDAR' : 'TR_CREAR');
        const displayInTasks = currentContractor.show_in_tasks;
        const isMonthly = formValues && formValues.values && formValues.values.monthly;
        const isMonthlyType = document_schema_type_id === DocumentSchemaType.MONTHLY;
        const isLinkedType = document_schema_type_id === DocumentSchemaType.LINKED_WORK_COMPANY
            || document_schema_type_id === DocumentSchemaType.LINKED_COMPANY_COMPANY
            || document_schema_type_id === DocumentSchemaType.LINKED_WORK_COMPANY_COMPANY;
        const isCompanyCompanyLinkedType = document_schema_type_id === DocumentSchemaType.LINKED_COMPANY_COMPANY;

        return (
            <Row clearfix>
                <Card loading={loading}>
                    <CardHeader title={title.toUpperCase()}/>
                    <CardBody>
                        <form onSubmit={handleSubmit(this.onSubmit)}>
                            <Row>
                                <div className="col-sm-12">
                                    <Field
                                        name="document_schema_type_id"
                                        component={this.renderRadioGroup}
                                        onChange={(event, value) => this.setState({ document_schema_type_id: value })}
                                    >
                                        {
                                            schemaOptions.map((object, i) => {
                                                return (
                                                    <RadioButton
                                                        key={i}
                                                        value={object.value}
                                                        label={object.name}
                                                        iconStyle={{ fill: 'gray', marginRight: '5px' }}
                                                        style={{
                                                            width: 'auto',
                                                            float: 'left',
                                                            paddingRight: '15px',
                                                        }}
                                                        disabled={disabledSchemaTypeField}
                                                    />
                                                );
                                            })
                                        }
                                    </Field>
                                </div>
                            </Row>
                            <Row>
                                <Field
                                    testId="form-name"
                                    label={I18nUtils.tr('TR_NONMBRE_DEL_TIPO_DE_DOCUMENTO') + ':'}
                                    placeholder={I18nUtils.tr('TR_INTRODUCE_EL_NONMBRE_DEL_TIPO_DE_DOCUMENTO')}
                                    name="name"
                                    type={'text'}
                                    colWidth="col-sm-6"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                                <div className="col-sm-6" test-id="form-file-types">
                                    <label style={{ 'marginBottom': '0px' }}>
                                        {I18nUtils.tr('TR_TIPO_DE_ADJUNTO') + ':'}
                                    </label>
                                    <Field
                                        name="filetypes"
                                        component={this.renderSelectField}
                                        multiple={true}
                                        fullWidth={true}
                                        floatingLabelFixed={false}
                                        hintText={I18nUtils.tr('TR_SELECCIONA_UNO_O_MAS_FORMATOS')}
                                        hintStyle={{ color: '#999', 'fontSize': '14px' }}
                                        selectedMenuItemStyle={{ backgroundColor: '#eee', color: '#555' }}
                                        menuItemStyle={{ color: '#555' }}
                                        disabled={disabled}
                                    >
                                        {
                                            fileTypes.map((object, i) => {
                                                return (
                                                    <MenuItem
                                                        key={i}
                                                        value={object.value}
                                                        primaryText={object.name}
                                                    />
                                                );
                                            })
                                        }
                                    </Field>
                                </div>
                            </Row>
                            <Row>
                                <Field
                                    testId="form-description"
                                    label={I18nUtils.tr('TR_INSTRUCCIONES_PARA_ESTE_TIPO_DE_DOCUMENTO') + ':'}
                                    placeholder={I18nUtils.tr('TR_INSTRUCCIONES_DEL_DOCUMENTO')}
                                    name="notes"
                                    type={'textarea'}
                                    rows={4}
                                    colWidth="col-sm-12"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                            </Row>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_CADUCA')}
                                    labelDisabled={I18nUtils.tr('TR_NO')}
                                    labelEnabled={I18nUtils.tr('TR_SI')}
                                    defaultChecked={true}
                                    name="expires"
                                    checked={false}
                                    type={'checkbox'}
                                    colWidth="col-md-2"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                                {
                                    isLinkedType ? (
                                        <Field
                                            label={I18nUtils.tr('TR_MENSUAL')}
                                            labelDisabled={I18nUtils.tr('TR_NO')}
                                            labelEnabled={I18nUtils.tr('TR_SI')}
                                            defaultChecked={true}
                                            name="monthly"
                                            checked={false}
                                            type={'checkbox'}
                                            colWidth="col-md-2"
                                            component={this.renderField}
                                            disabled={disabled}
                                        />
                                    ) : <div className="col-md-2"/>
                                }
                                {
                                    isLinkedType && isMonthly ? (
                                        <Field
                                            label={I18nUtils.tr('TR_ASOCIADO_A_PRESENCIA')}
                                            labelDisabled={I18nUtils.tr('TR_NO')}
                                            labelEnabled={I18nUtils.tr('TR_SI')}
                                            defaultChecked={true}
                                            name="construction_presence"
                                            checked={true}
                                            type={'checkbox'}
                                            colWidth="col-md-2"
                                            component={this.renderField}
                                            disabled={disabled}
                                        />
                                    ) : <div className="col-md-2"/>
                                }
                                {
                                    displayInTasks ? (
                                        <Field
                                            label={I18nUtils.tr('TR_MOSTRAR_EN_TAREAS')}
                                            labelDisabled={I18nUtils.tr('TR_NO')}
                                            labelEnabled={I18nUtils.tr('TR_SI')}
                                            defaultChecked={true}
                                            name="show_in_tasks"
                                            checked={true}
                                            type={'checkbox'}
                                            colWidth="col-md-2"
                                            component={this.renderField}
                                            disabled={disabled}
                                        />
                                    ) : <div className="col-md-2"/>
                                }
                                {
                                    isMonthlyType ? (
                                        <Field
                                            label={I18nUtils.tr('TR_VALIDACION_MULTIPLE')}
                                            labelDisabled={I18nUtils.tr('TR_NO')}
                                            labelEnabled={I18nUtils.tr('TR_SI')}
                                            defaultChecked={true}
                                            name="multiple_validation"
                                            checked={false}
                                            type={'checkbox'}
                                            colWidth="col-md-2"
                                            component={this.renderField}
                                            disabled={disabled}
                                        />
                                    ) : <div className="col-md-2"/>
                                }
                                {
                                    isMonthlyType ? (
                                        <Field
                                            label={I18nUtils.tr('TR_DOCUMENTO_RNT')}
                                            labelDisabled={I18nUtils.tr('TR_NO')}
                                            labelEnabled={I18nUtils.tr('TR_SI')}
                                            defaultChecked={true}
                                            name="is_rnt"
                                            checked={false}
                                            type={'checkbox'}
                                            colWidth="col-md-2"
                                            component={this.renderField}
                                            disabled={disabled}
                                        />
                                    ) : <div className="col-md-2"/>
                                }
                                {
                                    isCompanyCompanyLinkedType ? (
                                        <Field
                                            label={I18nUtils.tr('TR_CERTIFICADO_HACIENDA_CONTRATISTA_Y_SUBCONTRATISTA')}
                                            labelDisabled={I18nUtils.tr('TR_NO')}
                                            labelEnabled={I18nUtils.tr('TR_SI')}
                                            defaultChecked={true}
                                            name="is_certificado_hacienda_contratista"
                                            checked={false}
                                            type={'checkbox'}
                                            colWidth="col-md-4"
                                            component={this.renderField}
                                            disabled={disabled}
                                        />
                                    ) : <div className="col-md-4"/>
                                }
                            </Row>
                            <Row>
                                {!disabled &&
                                    <Field
                                        label={submitLabel.toUpperCase()}
                                        name="submit"
                                        type={'submit'}
                                        colWidth="col-md-2 col-md-offset-10"
                                        component={this.renderField}
                                        disabled={disabled}
                                    />
                                }
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Row>
        );
    }
}

function validate(values) {
    const errors = {};
    if ( !values.document_schema_type_id || values.document_schema_type_id === -1 ) {
        errors.document_schema_type_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }
    if ( !values.name ) {
        errors.name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }
    if ( !values.filetypes || values.filetypes.length === 0 ) {
        errors.filetypes = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    return errors;
}

let TypeDocumentsCreateFormCardReduxForm = reduxForm({
    validate,
    form: 'TypeDocumentsCreateForm',
})(TypeDocumentsFormCard);

let TypeDocumentsEditFormCardReduxForm = reduxForm({
    validate,
    form: 'TypeDocumentsEditForm',
})(TypeDocumentsFormCard);

const mapStateToProps = (state, ownProps) => {
    const currentContractor = state.auth.contractor;

    const schemaOptions = [];
    state.schemaType.schemaType.forEach((schema) => {
        if ( schema.id === 4 ) { // ocultamos el tipo documento obra
            return;
        }
        if ( schema.id !== DocumentSchemaType.LINKED ) {
            schemaOptions.push({
                value: schema.id,
                name: schema.name,
            });
        } else {
            schemaOptions.push({
                value: DocumentSchemaType.LINKED_WORK_COMPANY,
                name: I18nUtils.tr('TR_VINCULADOS_OBRA_EMPRESA'),
            });
            schemaOptions.push({
                value: DocumentSchemaType.LINKED_COMPANY_COMPANY,
                name: I18nUtils.tr('TR_VINCULADOS_EMPRESA_EMPRESA'),
            });
            schemaOptions.push({
                value: DocumentSchemaType.LINKED_WORK_COMPANY_COMPANY,
                name: I18nUtils.tr('TR_VINCULADOS_OBRA_EMPRESA_EMPRESA'),
            });
        }
    });

    const fileTypesOptions = state.typedocuments.fileTypes.map((filetype) => {
        return {
            value: filetype.id,
            name: filetype.name,
        };
    });

    let documentValues = {
        expires: false,
        monthly: false,
        construction_presence: false,
        show_in_tasks: currentContractor.show_in_tasks,
        document_schema_type_id: -1,
    };

    if ( ownProps.typedocument ) {
        documentValues = ownProps.typedocument;
        documentValues.document_schema_type_id = ownProps.typedocument.document_schema_type.id;
        if ( documentValues.document_schema_type_id === DocumentSchemaType.LINKED ) {
            if ( ownProps.typedocument.document_link_type && ownProps.typedocument.document_link_type.id ) {
                switch ( ownProps.typedocument.document_link_type.id ) {
                    case 1:
                        documentValues.document_schema_type_id = DocumentSchemaType.LINKED_WORK_COMPANY;
                        break;
                    case 2:
                        documentValues.document_schema_type_id = DocumentSchemaType.LINKED_COMPANY_COMPANY;
                        break;
                    case 3:
                        documentValues.document_schema_type_id = DocumentSchemaType.LINKED_WORK_COMPANY_COMPANY;
                        break;
                    default:
                        break;
                }
            }
        }

        let tifOptions = [];
        const obj = _.mapKeys(ownProps.typedocument.file_types, 'id');
        Object.keys(obj).forEach(function(key) {
            tifOptions.push(Number(key));
        });
        documentValues.filetypes = tifOptions;
    }

    return {
        initialValues: documentValues,
        schemaOptions: schemaOptions,
        fileTypes: fileTypesOptions,
        loading: state.typedocuments.typeDocumentLoading,
        formValues: state.form.TypeDocumentsCreateForm || state.form.TypeDocumentsEditForm,
        currentContractor,
    };
};

TypeDocumentsFormCard.propTypes = {
    disabled: PropTypes.bool,
    disabledSchemaTypeField: PropTypes.bool,
};

TypeDocumentsFormCard.defaultProps = {};

const mapDispatchToProps = dispatch => ( {
    typeDocumentsActions: bindActionCreators(typeDocumentsActions, dispatch),
} );

const StoreConnector = connect(mapStateToProps, mapDispatchToProps);

export const TypeDocumentsCreateFormCard = StoreConnector(TypeDocumentsCreateFormCardReduxForm);
export const TypeDocumentsEditFormCard = StoreConnector(TypeDocumentsEditFormCardReduxForm);



// WEBPACK FOOTER //
// ./src/app/documents/components/TypeDocumentsFormCard.jsx